import { createContext, useContext, useState } from "react";
import Toast from "../components/toast/Toast";

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState({
        show: false,
        message: ""
    });

    const showToast = (message, type = "success") => {
        setToast({ show: true, message, type });

        setTimeout(() => {
            setToast({ show: false, message: "", type: "success" });
        }, 2000);
    };

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}

            {/* GLOBAL TOAST */}
            <Toast
                message={toast.message}
                show={toast.show}
                type={toast.type}
                onClose={() => setToast({ show: false, message: "", type: "success" })}
            />
        </ToastContext.Provider>
    );
};